import * as Yup from 'yup';

export const name = Yup.string()
  .trim()
  .max(50, 'Name should be less than 50 symbols')
  .required('Name is required');
